import { render } from "./BakersStatus.vue?vue&type=template&id=67210534&scoped=true"
import script from "./BakersStatus.vue?vue&type=script&lang=js"
export * from "./BakersStatus.vue?vue&type=script&lang=js"

import "./BakersStatus.vue?vue&type=style&index=0&id=67210534&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67210534"]])

export default __exports__